import { render, staticRenderFns } from "./ReRegisterShipment.vue?vue&type=template&id=aa799b04&"
import script from "./ReRegisterShipment.vue?vue&type=script&lang=js&"
export * from "./ReRegisterShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports